import { render, staticRenderFns } from "./StreamMetrics.vue?vue&type=template&id=486681e5&scoped=true&"
import script from "./StreamMetrics.vue?vue&type=script&setup=true&lang=js&"
export * from "./StreamMetrics.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./StreamMetrics.vue?vue&type=style&index=0&id=486681e5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486681e5",
  null
  
)

export default component.exports